export default "__VITE_ASSET__DSc4zkGn__"